export const CONTENT = {
    "labels": {
        "customer_assistance_tool": "CUSTOMER ASSISTANCE TOOLS",
        "admin_tools": "ADMIN TOOLS",              
    }
}  